import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ServiceDetailPageContainer, ServiceImage } from './ServiceDetailPage';
import { FaPaperPlane } from 'react-icons/fa';
import emailjs from '@emailjs/browser';

const ContactSection = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(45deg, #00B4DB, #007bff);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: white;
  position: relative;
  overflow: hidden;
  margin-top: 8rem;
  border-radius: 20px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), transparent);
    transform: skewX(-20deg) translateX(30%);
    transform-origin: top right;
    pointer-events: none;
    z-index: 0;
  }
`;

const ContactContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 600px;
  width: 100%;
`;

export const ContactTitle = styled.h2`
  color: #fff !important;
  margin-top: 0 !important;
`;

const ContactForm = styled.form`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const ContactInput = styled.input`
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  flex: 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f2937;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const SubmitButton = styled.button`
  background: #00B4DB;
  color: white;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 180, 219, 0.2);

  &:hover {
    background: #007bff;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 180, 219, 0.3);
  }

  svg {
    margin: 0;
  }
`;

function AdvertisingManagement() {
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      // Only allow numbers and limit to exactly 11 digits
      const numbersOnly = value.replace(/[^\d]/g, '');
      if (numbersOnly.length <= 11) {
        setFormData({
          ...formData,
          [name]: numbersOnly
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.phone.length !== 11) {
      alert('Telefon numarası 11 haneli olmalıdır.');
      return;
    }

    try {
      const templateParams = {
        name: formData.name,
        phone: formData.phone,
        time: new Date().toLocaleString('tr-TR')
      };

      await emailjs.send(
        'service_771tgg7',
        'template_w676du8',
        templateParams,
        'xjG6_a9zdp6ZU1zHp'
      );

      alert('Başarılı');
      setFormData({ name: '', phone: '' });
    } catch (error) {
      alert('Bir hata oluştu');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ServiceDetailPageContainer>
      <h1>Reklam Yönetimi</h1>
      <p>Google Ads ve sosyal medya reklamlarıyla hedef kitlenize ulaşarak dönüşümlerinizi artırıyoruz. Kapsamlı analizler ve stratejik kampanyalarla reklam bütçenizin en verimli şekilde kullanılmasını sağlıyoruz.</p>

      <ServiceImage src="/media/demirer-ajans-8.png" alt="Reklam Yönetimi Görseli 1" />

      <h2>Neden Profesyonel Reklam Yönetimi Önemlidir?</h2>
      <p>Dijital reklamcılık, markaların kısa sürede geniş kitlelere ulaşması ve ölçülebilir sonuçlar elde etmesi için en güçlü araçlardan biridir. Ancak, doğru kitleyi hedeflemek, etkili reklam metinleri ve görselleri oluşturmak, bütçeyi optimize etmek uzmanlık gerektirir. Profesyonel reklam yönetimi, yatırım getirinizi maksimize eder.</p>

      <ServiceImage src="/media/demirer-ajans-1.png" alt="Reklam Yönetimi Görseli 2" />

      <h3>Hizmetlerimiz Neleri Kapsar?</h3>
      <ul>
        <li><b>Google Ads Yönetimi:</b> Arama Ağı, Görüntülü Reklam Ağı, YouTube ve Alışveriş reklamları dahil tüm Google Ads kampanyalarının kurulumu, yönetimi ve optimizasyonu.</li>
        <li><b>Sosyal Medya Reklamcılığı:</b> Facebook, Instagram, LinkedIn, X (Twitter) gibi platformlarda hedefli reklam kampanyaları oluşturma ve yönetme.</li>
        <li><b>Hedef Kitle Analizi ve Segmentasyon:</b> Doğru demografik, ilgi alanı ve davranışsal hedeflerle reklamlarınızın doğru kişilere ulaşmasını sağlama.</li>
        <li><b>Reklam Metni ve Görsel Oluşturma:</b> Dikkat çekici, dönüşüm odaklı reklam metinleri ve profesyonel görseller/videolar hazırlama.</li>
        <li><b>Bütçe Optimizasyonu:</b> Reklam bütçenizin en verimli şekilde kullanılmasını sağlayacak stratejiler ve teklif yönetimi.</li>
        <li><b>Dönüşüm Takibi ve Raporlama:</b> Reklam kampanyalarının performansını detaylı olarak izleme, dönüşümleri takip etme ve düzenli raporlama.</li>
        <li><b>A/B Testleri:</b> Farklı reklam öğelerini test ederek en yüksek performansı sunan kombinasyonları belirleme.</li>
      </ul>

      <h2>Reklam Bütçeniz İçin Nasıl Değer Yaratıyoruz?</h2>
      <ServiceImage src="/media/demirer-ajans-2.png" alt="Reklam Yönetimi Görseli 3" />
      <p>Her kampanyayı, işletmenizin özel hedeflerine ve bütçesine göre şekillendiriyoruz. Sürekli izleme, analiz ve optimizasyon ile reklam harcamalarınızdan en yüksek geri dönüşü almanızı sağlıyoruz. Sadece tıklama değil, gerçek dönüşümler ve iş büyümesi odaklı çalışıyoruz.</p>
      <p>Dijital reklamcılığın karmaşık dünyasında sizin için rehberlik etmek ve markanızın büyümesini hızlandırmak için bize güvenebilirsiniz.</p>

      <h2>Reklam Yönetimi Hizmetlerimiz</h2>
      <p>Reklam yönetimi hizmetlerimiz, işletmenizin dijital reklam kampanyalarını optimize etmek için tasarlanmıştır. Uzman ekibimiz, kampanya stratejisi, bütçe yönetimi ve performans analizi konularında profesyonel çözümler sunar.</p>
      <p>Veri odaklı yaklaşım ve sürekli optimizasyonla, reklam yatırımlarınızın getirisini artırıyoruz. İşletmenizin dijital pazarlama başarısını artırmak için bize güvenebilirsiniz.</p>

      <ContactSection>
        <ContactContent>
          <ContactTitle>Sizi Arayalım</ContactTitle>
          <ContactForm onSubmit={handleSubmit}>
            <ContactInput 
              type="text" 
              name="name"
              placeholder="Adınız"
              value={formData.name}
              onChange={handleInputChange}
              required 
            />
            <ContactInput 
              type="tel" 
              name="phone"
              placeholder="Telefon Numaranız (11 Haneli)"
              value={formData.phone}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength="11"
              minLength="11"
              required 
            />
            <SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPaperPlane />
            </SubmitButton>
          </ContactForm>
        </ContactContent>
      </ContactSection>
    </ServiceDetailPageContainer>
  );
}

export default AdvertisingManagement; 